import React from 'react';
import PropTypes from 'prop-types';
export default function IconRedFeatureSubmerchant({ className }){
  return(
    <svg className={className} fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#FFECE0" height="32" rx="16" width="32"/>
      <path d="M18 18H20V20H18V18ZM11 8H21C21.1484 8 21.2891 8.06591 21.3841 8.17991L23.8841 11.1799C24.0009 11.32 24.0005 11.3912 24.0001 11.4823L24 11.5V13C24 13.8885 23.6137 14.6868 23 15.2361V23.5C23 23.7761 22.7761 24 22.5 24H16V17.5C16 17.2239 15.7761 17 15.5 17H11.5C11.2239 17 11 17.2239 11 17.5V24H9.5C9.22386 24 9 23.7761 9 23.5V15.2361C8.38625 14.6868 8 13.8885 8 13V11.5C8.00002 11.3852 8.03955 11.2715 8.1159 11.1799L10.6159 8.17991C10.7109 8.06591 10.8516 8 11 8ZM9 12V13C9 14.1046 9.89543 15 11 15C12.1046 15 13 14.1046 13 13V12H9ZM14 12V13C14 14.1046 14.8954 15 16 15C17.1046 15 18 14.1046 18 13V12H14ZM19 12V13C19 14.1046 19.8954 15 21 15C22.1046 15 23 14.1046 23 13V12H19ZM11.2342 9L9.56753 11H13.1396L13.8063 9H11.2342ZM17.8063 11L17.1396 9H14.8604L14.1937 11H17.8063ZM18.8604 11H22.4325L20.7658 9H18.1937L18.8604 11ZM17 17.5V20.5C17 20.7761 17.2239 21 17.5 21H20.5C20.7761 21 21 20.7761 21 20.5V17.5C21 17.2239 20.7761 17 20.5 17H17.5C17.2239 17 17 17.2239 17 17.5ZM15 24V18H12V24H15Z" fill="#FF711A"/>
    </svg>

  );
}
IconRedFeatureSubmerchant.defaultProps = {
  className: ''
};
IconRedFeatureSubmerchant.propTypes = {
  className: PropTypes.string
};
